import React from 'react';

const PermintaanSDM = () => {
  return (
    <h1>Permintaan SDM</h1>
  );
};

export default PermintaanSDM;





